






















import isURL from 'validator/es/lib/isURL'
import { ValidationProvider, extend, localize } from 'vee-validate'
import { required, email, min_value, required_if, max_value, numeric, integer, length, min } from 'vee-validate/dist/rules'
import { Component, Mixins } from 'vue-property-decorator'

import { EditorData } from '../../../logic/types'
import MessageEditorWithMediaData from "../../NewMessageEditors/NewMessageEditorWithMedia/types";
import { Field } from '../mixins'

@Component({
  components: {
    ValidationProvider,
  },
})
export default class Validation extends Mixins(Field) {
  created(): void {
    localize(this.$i18n.locale)

    extend('length', length)
    extend('email', email)
    extend('numeric', numeric)
    extend('integer', integer)
    extend('required', required)
    extend('min_value', min_value)
    extend('max_value', max_value)
    extend('min', min)
    extend('url', {
      validate: (value, params) => {
        const require_protocol = (params as Record<string, any>)?.require_protocol !== undefined ?? false

        return isURL(value, { require_protocol })
      },
      params: [ 'require_protocol' ],
    })
    // extend('url_or_placeholder', {
    //   validate: (value:string) => {
    //     return isURL(value)
    //       || value.length > 2 && ((value.startsWith('%') && value.endsWith('%')) || (value.startsWith('{') && value.endsWith('}'))
    //       )
    //   },
    // })
    extend('alpha_num_spaces', {
      validate: (value) => /^[А-Яа-я\w\s_]+$/.test(value),
      message: () => this.$t('alpha_num_spaces_validation_error').toString(),
    })

    extend('editor_not_empty', {
      validate: (value: MessageEditorWithMediaData | Array<MessageEditorWithMediaData>) => {
        const textIsNotEmpty = (editor: MessageEditorWithMediaData) => !!editor.text.trim().length && editor.text !== '\n'
        const attachmentsIsNotEmpty = (editor: MessageEditorWithMediaData) => !!editor.attachments.length

        if (Array.isArray(value)) {
          return value.every(v => textIsNotEmpty(v) || attachmentsIsNotEmpty(v))
        }

        return textIsNotEmpty(value) || attachmentsIsNotEmpty(value)
      },
    })

    extend('tg_url_or_url_or_placeholder', {
      validate: (value, params) => {

        if (/.*\.t.me+(\/)?$/.test(value) || (/^tg:\/\/.*/.test(value))) {
          return true
        } else {
          const require_protocol = (params as Record<string, any>)?.require_protocol !== undefined ?? false

          return isURL(value, { require_protocol }) || value.length > 2 && ((value.startsWith('%') && value.endsWith('%')) || (value.startsWith('{') && value.endsWith('}')))
        }
      },
      params: [ 'require_protocol' ],
      message: () => this.$t('url_rule_validation_error').toString(),
    })

    extend('always_true', {
      validate: (value) => value === true,
    })

    extend('required_if_not', {
      ...required_if,
      // params: ['target']
      validate: (value, args) => {
        const targetValue = (args as any).target
        return Boolean(targetValue || value)
      },
      message: () => this.$t('required_if_not').toString(),
    })

    extend('depends_on_multi_editor_required_text', {
      params: [ 'targetValue', 'messageKey' ],
      validate: (value, params) => {
        const multiEditorValue: Array<EditorData> = (params as any).targetValue
        return multiEditorValue
          && !!multiEditorValue.length
          && multiEditorValue.some((editor) => editor.text.length > 0)
      },
      message: (_, { messageKey }): any => this.$t(messageKey).toString(),
    })

    extend('urlBraces', {
      validate: (value) => isURL(value) || value.includes('{') && value.includes('}'),
      message: () => this.$t('url_rule_validation_error').toString(),
    })

    extend('is_not_0', { validate: (val) => val !== 0, message: this.$t('validation_is_not_0').toString })

    this.$i18n.mergeLocaleMessage('ru', {
      url_rule_validation_error: 'Неправильно указана ссылка',
      required_if_not: 'Заполните одно из полей',
    })
    this.$i18n.mergeLocaleMessage('en', {
      url_rule_validation_error: 'Url is not valid',
      required_if_not: 'At least one field required',
    })

    localize({
      ru: {
        messages: {
          required: 'Обязательное поле',
          email: 'Неправильно введен Email',
          min_value: (_, { min }): string => `Минимальное значение ${ min }`,
          max_value: (_, { max }): string => `Максимальное значение ${ max }`,
          url: 'Неправильно указан url',
          always_true: 'Обязательное поле',
          required_if_not: 'Заполните одно из полей',
          integer: 'Значение должно быть числом',
          length: (_, { length }) => {
            return `Поле должно быть длиной ${ length }`
          },
          'min': (_, { length }): string => `Минимум ${ length } символов`,
          'editor_not_empty': 'Заполните текст или добавьте медиа'
        },
      },
      en: {
        messages: {
          required: 'This field is required',
          email: 'Email is not valid',
          url: 'Url is not valid',
          min_value: (_, { min }): string => `Minimum value is ${ min }`,
          max_value: (_, { max }): string => `Minimum value is ${ max }`,
          always_true: 'This field is required',
          required_if_not: 'Fill at least one field',
          integer: 'Value must be integer',
          // eslint-disable-next-line sonarjs/no-identical-functions
          length: (_, { length }) => {
            return `Field must be ${ length } long`
          },
          'min': (_, { length }): string => `Minimum ${ length } symbols`,
          'editor_not_empty': 'Fill in the text or add media'
        },
      },
    })
  }
}
